import {productsActionTypes} from "../constants/ActionTypes";

const initialState = {
  products: [],
  pagination: {
    currentPage: 1,
    pagesCount: 0,
    recordsCount: 0
  },
  productsForCopying: {},
  forms: {
    size: {
      size: null,
      open: false
    }
  },
  imageOrdering: {
    id: null,
    isLoading: false,
    isRequestPending: false,
    error: null
  }
};

const products = (state = initialState, action) => {
  switch (action.type) {
    case productsActionTypes.SET_PRODUCTS_LIST:
      return Object.assign({}, state, {
        products: action.products,
        pagination: action.pagination
      });
    case productsActionTypes.GET_PRODUCT_DATA_FOR_COPYING:
      return {
        ...state,
        productsForCopying: {
          ...state.productsForCopying,
          [action.product.id]: action.product
        }
      };
    // image ordering
    case productsActionTypes.REQUEST_IMAGE_ORDERING:
      return {
        ...state,
        imageOrdering: {
          isLoading: true,
          isRequestPending: true,
          id: action.productId
        }
      };
    case productsActionTypes.REQUEST_IMAGE_ORDERING_DONE:
      return {
        ...state,
        imageOrdering: {
          isLoading: false,
          isRequestPending: false,
          id: action.product.id,
          product: action.product,
          productType: action.productType,
          importRules: action.importRules,
          imagesAvailableLocally: action.imagesAvailableLocally,
          imagesAvailableGlobally: action.imagesAvailableGlobally,
          imagesSpecialSlots: action.imagesSpecialSlots,
          centralMediaHost: action.centralMediaHost
        }
      };
    case productsActionTypes.REQUEST_IMAGE_ORDERING_ERROR:
      return {
        ...state,
        imageOrdering: {
          isLoading: false,
          id: state.imageOrdering.id,
          error: action.error
        }
      };
    case productsActionTypes.SAVE_IMAGES_ORDERING_REQUEST:
      return {
        ...state,
        imageOrdering: {
          ...state.imageOrdering,
          isRequestPending: true
        }
      };
    case productsActionTypes.SAVE_IMAGES_ORDERING_DONE:
      return {
        ...state,
        imageOrdering: {
          ...state.imageOrdering,
          isRequestPending: false,
          product: action.product
        }
      };
  }

  return state;
};

export default products;



// WEBPACK FOOTER //
// ./reducers/products.reducers.js